export default function CTASection() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Image Container */}
          <div className="relative rounded-3xl overflow-hidden mb-12 md:mb-16 mx-auto max-w-2xl">
            <div className="aspect-[16/10] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20carefully%20curated%20fashion%20collection%20with%20folded%20linen%20garments%20leather%20accessories%20and%20elegant%20jewelry%20on%20warm%20cream%20surface%2C%20soft%20diffused%20Mediterranean%20natural%20light%20from%20above%2C%20minimal%20editorial%20product%20styling%2C%20terracotta%20and%20sand%20tones%2C%20sophisticated%20luxury%20flat%20lay&width=1200&height=750&seq=itaobuy-cta-v2&orientation=landscape"
                alt="Itaobuy Spreadsheet shopping collection"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
          </div>

          {/* Text */}
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            Scopri <span className="italic font-light text-foreground-600">itaobuy sheet</span>
          </h2>
          <p className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-400 font-light italic mt-2">
            shopping intelligente
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center mt-10 px-10 py-4 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2 text-base"></i>
            Itaobuy Sheet &mdash; Acquista Ora
          </a>
        </div>
      </div>
    </section>
  );
}